/*
 *  IsAndroidMobile
 *  IsAndroidNativeBrowser
 *  MinWidth
 *  MaxWidth
 *  DeviceOrientation
*/
var MediaQueries;
(function (MediaQueries) {
    // Note to developers: The following methods may or may not be necessary, but may be useful in certain situations
    // User Agent
    var navU = navigator.userAgent;
    function IsAndroidMobile() {
        return navU.indexOf('Android') > -1 && navU.indexOf('Mozilla/5.0') > -1 && navU.indexOf('AppleWebKit') > -1;
    }
    MediaQueries.IsAndroidMobile = IsAndroidMobile;
    function IsAndroidNativeBrowser() {
        var regExAppleWebKit = new RegExp(/AppleWebKit\/([\d.]+)/), resultAppleWebKitRegEx = regExAppleWebKit.exec(navU), appleWebKitVersion = (resultAppleWebKitRegEx === null ? null : parseFloat(regExAppleWebKit.exec(navU)[1]));
        return this.IsAndroidMobile() && appleWebKitVersion !== null && appleWebKitVersion < 537;
    }
    MediaQueries.IsAndroidNativeBrowser = IsAndroidNativeBrowser;
    function MinWidth(minWidthValue) {
        if (Modernizr.mq !== undefined) {
            if (Modernizr.mq('only screen and (min-width: ' + minWidthValue + ')')) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false; //"\"Media Queries\" is not an included detect in your Modernizr build.";
        }
    }
    MediaQueries.MinWidth = MinWidth;
    function MaxWidth(maxWidthValue) {
        if (Modernizr.mq !== undefined) {
            if (Modernizr.mq('only screen and (max-width: ' + maxWidthValue + ')')) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false; //"\"Media Queries\" is not an included detect in your Modernizr build.";
        }
    }
    MediaQueries.MaxWidth = MaxWidth;
    function DeviceOrientation() {
        if (Modernizr.mq !== undefined) {
            if (Modernizr.mq('only screen and (orientation:portrait)')) {
                return "portrait";
            }
            else if (Modernizr.mq('only screen and (orientation:landscape)')) {
                return "landscape";
            }
            else {
                return null;
            }
        }
        else {
            return null; //"\"Media Queries\" is not an included detect in your Modernizr build."; 
        }
    }
    MediaQueries.DeviceOrientation = DeviceOrientation;
    // Adds user agent (lets us detect browsers and style through CSS)
    function AddUserAgentAsClass() {
        var doc = document.documentElement;
        doc.setAttribute('data-useragent', navigator.userAgent);
    }
    MediaQueries.AddUserAgentAsClass = AddUserAgentAsClass;
    // Loads fastclick.js if we're on a touch device
    function FastClickInit() {
        Modernizr.load({
            test: Modernizr.touch,
            yep: 'https://cdnjs.cloudflare.com/ajax/libs/fastclick/1.0.6/fastclick.min.js',
            nope: null,
            complete: function () {
                if (Modernizr.touch) {
                    $(function () {
                        FastClick.attach(document.body, { ignoreClass: "^pac-" });
                    });
                }
            }
        });
    }
    MediaQueries.FastClickInit = FastClickInit;
})(MediaQueries || (MediaQueries = {}));
